
import React from 'react';
import { Copyright } from './Copyright';
import { AdminLink } from './AdminLink';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-800 to-sky-800 text-white py-3 md:py-4 mt-4">
      <div className="container mx-auto px-3 md:px-4 flex flex-col md:flex-row-reverse md:justify-between items-center gap-2 md:gap-0">
        <AdminLink />
        <Copyright />
      </div>
    </footer>
  );
};

export default Footer;
